<script setup lang="ts">
import type { CustomerListItem } from '@entities/customer'

import { faLink, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useCustomerActions } from '../../model/list/customer-actions.hook'

defineOptions({
  name: 'CustomerRowActions',
})

const props = defineProps<{
  customer: CustomerListItem
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  canManage,
  canDelete,
  toggle,
  openCustomer,
  actOnBehalf,
  askDelete,
} = useCustomerActions({
  customer: computed(() => props.customer),
})
</script>

<template>
  <div
    ref="containerRef"
    class="customer-row-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for customer #${customer.id}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="customer-row-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="View customer"
          color="blue"
          :prepend-icon="faLink"
          @click="openCustomer"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Act on behalf"
          color="blue"
          :prepend-icon="faLink"
          @click="actOnBehalf"
        />
        <AppDropdownItem
          v-if="canDelete"
          text="Delete customer"
          color="red"
          :prepend-icon="faTrashCan"
          @click="askDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerRowActions.scss" />
